import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { TeamState } from '../states';

export enum TeamFallbackType {
    NotSet = 'not-set',
    NotAssigned = 'not-assigned'
}

@Pipe({ name: 'teamName', pure: false })
export class TeamNamePipe implements PipeTransform {
    private store = inject(Store);
    private translate = inject(TranslateService);

    public transform(
        value: string | null | undefined,
        fallbackType: TeamFallbackType = TeamFallbackType.NotSet
    ): Observable<string> {
        if (!value) {
            const translationKey =
                fallbackType === TeamFallbackType.NotAssigned
                    ? 'common.request-tables.team-not-assigned'
                    : 'common.request-tables.team-not-set';
            return of(this.translate.instant(translationKey));
        }

        return this.store.select(TeamState.allTeams).pipe(
            map((teams) => {
                if (teams && teams.length > 0) {
                    const team = teams.find((t) => t.id === value);
                    if (team) {
                        return team.name || '-';
                    }
                    // If team not found, return the value itself or a placeholder
                    return `Team ID: ${value}`;
                }
                // When teams are loading or not available, use the specified fallback type
                const translationKey =
                    fallbackType === TeamFallbackType.NotAssigned
                        ? 'common.request-tables.team-not-assigned'
                        : 'common.request-tables.team-not-set';
                return this.translate.instant(translationKey);
            })
        );
    }
}
